const actionTypes = {
    UPDATE_BANNER_HEIGHT: 'PREVIEW/UPDATE_BANNER_HEIGHT',
};

export default actionTypes;
